export const environment = {
  production: false,
  baseURL: 'http://localhost:3000/api',

  projectName: 'genai-agency',

  version: '0.0.4',
};
